<script setup>
import { useDetectDevice } from '@/composables/device'

import InvoicesGrid from '@/components/accounting/InvoicesGrid.vue'
import InvoicesView from '@/components/accounting/InvoicesView.vue'

const { isMobile } = useDetectDevice()
</script>
<template>
  <invoices-view v-if="isMobile" />
  <invoices-grid v-else />
</template>
